import { render } from "./ChannelPage.vue?vue&type=template&id=f9825a28"
import script from "./ChannelPage.vue?vue&type=script&lang=js"
export * from "./ChannelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__